// Yofis — контракт API `yofis.v1`. Звонки: комнаты на LiveKit в поставке компании (ADR-011).
//
// Контракт — v1; реализация — обновление 1 пилота (`Capabilities.calls`). Медиа ходит через
// LiveKit узла (`media_url`, `media_token`), сигналинг — через узел.
//
// Встречи по ссылке для внешних участников **описаны здесь же и в `link.proto`**, отдельного
// `MeetingService` нет и не будет (ADR-037): комната без чата — это `Room` с пустым `chat_id`,
// ссылка — `LINK_SCOPE_ROOM_JOIN`, вход гостя — `AuthService.JoinAsGuest`, лобби — `LinkService`.
// Прежняя шапка обещала `MeetingService` в v2 и устарела: она писалась до того, как гость и лобби
// вошли в контракт. Пометка v1.5 у `ROOM_JOIN` — про срок реализации, а не про наличие в контракте.

// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=ts"
// @generated from file yofis/v1/call.proto (package yofis.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file yofis/v1/call.proto.
 */
export const file_yofis_v1_call: GenFile = /*@__PURE__*/
  fileDesc("ChN5b2Zpcy92MS9jYWxsLnByb3RvEgh5b2Zpcy52MSLTAQoEUm9vbRIKCgJpZBgBIAEoCRIPCgdjaGF0X2lkGAIgASgJEg0KBXRpdGxlGAMgASgJEhIKCmNyZWF0ZWRfYnkYBCABKAkSLgoKc3RhcnRlZF9hdBgFIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASGQoRcGFydGljaXBhbnRfY291bnQYBiABKAUSHQoVcGFydGljaXBhbnRfYWRkcmVzc2VzGAcgAygJEg4KBmFjdGl2ZRgIIAEoCBIRCglyZWNvcmRpbmcYCSABKAgiTAoRQ3JlYXRlUm9vbVJlcXVlc3QSDwoHY2hhdF9pZBgBIAEoCRINCgV0aXRsZRgCIAEoCRIXCg9pZGVtcG90ZW5jeV9rZXkYAyABKAkiMgoSQ3JlYXRlUm9vbVJlc3BvbnNlEhwKBHJvb20YASABKAsyDi55b2Zpcy52MS5Sb29tIiIKD0pvaW5Sb29tUmVxdWVzdBIPCgdyb29tX2lkGAEgASgJIlgKEEpvaW5Sb29tUmVzcG9uc2USHAoEcm9vbRgBIAEoCzIOLnlvZmlzLnYxLlJvb20SEQoJbWVkaWFfdXJsGAIgASgJEhMKC21lZGlhX3Rva2VuGAMgASgJIiMKEExlYXZlUm9vbVJlcXVlc3QSDwoHcm9vbV9pZBgBIAEoCSITChFMZWF2ZVJvb21SZXNwb25zZSIhCg5FbmRSb29tUmVxdWVzdBIPCgdyb29tX2lkGAEgASgJIhEKD0VuZFJvb21SZXNwb25zZSInChRHZXRBY3RpdmVSb29tUmVxdWVzdBIPCgdjaGF0X2lkGAEgASgJIjUKFUdldEFjdGl2ZVJvb21SZXNwb25zZRIcCgRyb29tGAEgASgLMg4ueW9maXMudjEuUm9vbSIYChZMaXN0QWN0aXZlUm9vbXNSZXF1ZXN0IjgKF0xpc3RBY3RpdmVSb29tc1Jlc3BvbnNlEh0KBXJvb21zGAEgAygLMg4ueW9maXMudjEuUm9vbTLJAwoLQ2FsbFNlcnZpY2USRwoKQ3JlYXRlUm9vbRIbLnlvZmlzLnYxLkNyZWF0ZVJvb21SZXF1ZXN0GhwueW9maXMudjEuQ3JlYXRlUm9vbVJlc3BvbnNlEkEKCEpvaW5Sb29tEhkueW9maXMudjEuSm9pblJvb21SZXF1ZXN0GhoueW9maXMudjEuSm9pblJvb21SZXNwb25zZRJECglMZWF2ZVJvb20SGi55b2Zpcy52MS5MZWF2ZVJvb21SZXF1ZXN0GhsueW9maXMudjEuTGVhdmVSb29tUmVzcG9uc2USPgoHRW5kUm9vbRIYLnlvZmlzLnYxLkVuZFJvb21SZXF1ZXN0GhkueW9maXMudjEuRW5kUm9vbVJlc3BvbnNlElAKDUdldEFjdGl2ZVJvb20SHi55b2Zpcy52MS5HZXRBY3RpdmVSb29tUmVxdWVzdBofLnlvZmlzLnYxLkdldEFjdGl2ZVJvb21SZXNwb25zZRJWCg9MaXN0QWN0aXZlUm9vbXMSIC55b2Zpcy52MS5MaXN0QWN0aXZlUm9vbXNSZXF1ZXN0GiEueW9maXMudjEuTGlzdEFjdGl2ZVJvb21zUmVzcG9uc2VCRQoRcnUueW9maXMucHJvdG8udjFQAVomeW9maXMucnUveW9maXMvZ2VuL2dvL3lvZmlzL3YxO3lvZmlzdjG6AgVZb2Zpc2IGcHJvdG8z", [file_google_protobuf_timestamp]);

/**
 * Комната звонка.
 *
 * @generated from message yofis.v1.Room
 */
export type Room = Message<"yofis.v1.Room"> & {
  /**
   * Идентификатор `<snowflake>@<home_domain>` (ADR-024).
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Чат, к которому привязана; пусто — комната без чата (встреча).
   *
   * @generated from field: string chat_id = 2;
   */
  chatId: string;

  /**
   * Название.
   *
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * Кто создал.
   *
   * @generated from field: string created_by = 4;
   */
  createdBy: string;

  /**
   * Когда начата.
   *
   * @generated from field: google.protobuf.Timestamp started_at = 5;
   */
  startedAt?: Timestamp | undefined;

  /**
   * Сколько участников сейчас.
   *
   * @generated from field: int32 participant_count = 6;
   */
  participantCount: number;

  /**
   * Адреса участников сейчас.
   *
   * @generated from field: repeated string participant_addresses = 7;
   */
  participantAddresses: string[];

  /**
   * Идёт (не завершена).
   *
   * @generated from field: bool active = 8;
   */
  active: boolean;

  /**
   * Идёт запись.
   *
   * @generated from field: bool recording = 9;
   */
  recording: boolean;
};

/**
 * Describes the message yofis.v1.Room.
 * Use `create(RoomSchema)` to create a new message.
 */
export const RoomSchema: GenMessage<Room> = /*@__PURE__*/
  messageDesc(file_yofis_v1_call, 0);

/**
 * Создание комнаты.
 *
 * @generated from message yofis.v1.CreateRoomRequest
 */
export type CreateRoomRequest = Message<"yofis.v1.CreateRoomRequest"> & {
  /**
   * Чат; опционально.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;

  /**
   * Название; пусто — по чату.
   *
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * Ключ идемпотентности (UUIDv7).
   *
   * @generated from field: string idempotency_key = 3;
   */
  idempotencyKey: string;
};

/**
 * Describes the message yofis.v1.CreateRoomRequest.
 * Use `create(CreateRoomRequestSchema)` to create a new message.
 */
export const CreateRoomRequestSchema: GenMessage<CreateRoomRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_call, 1);

/**
 * Ответ на создание комнаты.
 *
 * @generated from message yofis.v1.CreateRoomResponse
 */
export type CreateRoomResponse = Message<"yofis.v1.CreateRoomResponse"> & {
  /**
   * Комната.
   *
   * @generated from field: yofis.v1.Room room = 1;
   */
  room?: Room | undefined;
};

/**
 * Describes the message yofis.v1.CreateRoomResponse.
 * Use `create(CreateRoomResponseSchema)` to create a new message.
 */
export const CreateRoomResponseSchema: GenMessage<CreateRoomResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_call, 2);

/**
 * Вход в комнату.
 *
 * @generated from message yofis.v1.JoinRoomRequest
 */
export type JoinRoomRequest = Message<"yofis.v1.JoinRoomRequest"> & {
  /**
   * Идентификатор комнаты.
   *
   * @generated from field: string room_id = 1;
   */
  roomId: string;
};

/**
 * Describes the message yofis.v1.JoinRoomRequest.
 * Use `create(JoinRoomRequestSchema)` to create a new message.
 */
export const JoinRoomRequestSchema: GenMessage<JoinRoomRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_call, 3);

/**
 * Ответ на вход в комнату.
 *
 * @generated from message yofis.v1.JoinRoomResponse
 */
export type JoinRoomResponse = Message<"yofis.v1.JoinRoomResponse"> & {
  /**
   * Комната.
   *
   * @generated from field: yofis.v1.Room room = 1;
   */
  room?: Room | undefined;

  /**
   * Адрес медиасервера (LiveKit) узла; сигналинг — через узел.
   *
   * @generated from field: string media_url = 2;
   */
  mediaUrl: string;

  /**
   * Токен LiveKit для этого участника; короткоживущий.
   *
   * @generated from field: string media_token = 3;
   */
  mediaToken: string;
};

/**
 * Describes the message yofis.v1.JoinRoomResponse.
 * Use `create(JoinRoomResponseSchema)` to create a new message.
 */
export const JoinRoomResponseSchema: GenMessage<JoinRoomResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_call, 4);

/**
 * Выход из комнаты.
 *
 * @generated from message yofis.v1.LeaveRoomRequest
 */
export type LeaveRoomRequest = Message<"yofis.v1.LeaveRoomRequest"> & {
  /**
   * Идентификатор комнаты.
   *
   * @generated from field: string room_id = 1;
   */
  roomId: string;
};

/**
 * Describes the message yofis.v1.LeaveRoomRequest.
 * Use `create(LeaveRoomRequestSchema)` to create a new message.
 */
export const LeaveRoomRequestSchema: GenMessage<LeaveRoomRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_call, 5);

/**
 * Ответ на выход; полей нет.
 *
 * @generated from message yofis.v1.LeaveRoomResponse
 */
export type LeaveRoomResponse = Message<"yofis.v1.LeaveRoomResponse"> & {
};

/**
 * Describes the message yofis.v1.LeaveRoomResponse.
 * Use `create(LeaveRoomResponseSchema)` to create a new message.
 */
export const LeaveRoomResponseSchema: GenMessage<LeaveRoomResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_call, 6);

/**
 * Завершение комнаты.
 *
 * @generated from message yofis.v1.EndRoomRequest
 */
export type EndRoomRequest = Message<"yofis.v1.EndRoomRequest"> & {
  /**
   * Идентификатор комнаты.
   *
   * @generated from field: string room_id = 1;
   */
  roomId: string;
};

/**
 * Describes the message yofis.v1.EndRoomRequest.
 * Use `create(EndRoomRequestSchema)` to create a new message.
 */
export const EndRoomRequestSchema: GenMessage<EndRoomRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_call, 7);

/**
 * Ответ на завершение; полей нет.
 *
 * @generated from message yofis.v1.EndRoomResponse
 */
export type EndRoomResponse = Message<"yofis.v1.EndRoomResponse"> & {
};

/**
 * Describes the message yofis.v1.EndRoomResponse.
 * Use `create(EndRoomResponseSchema)` to create a new message.
 */
export const EndRoomResponseSchema: GenMessage<EndRoomResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_call, 8);

/**
 * Запрос активной комнаты чата.
 *
 * @generated from message yofis.v1.GetActiveRoomRequest
 */
export type GetActiveRoomRequest = Message<"yofis.v1.GetActiveRoomRequest"> & {
  /**
   * Идентификатор чата.
   *
   * @generated from field: string chat_id = 1;
   */
  chatId: string;
};

/**
 * Describes the message yofis.v1.GetActiveRoomRequest.
 * Use `create(GetActiveRoomRequestSchema)` to create a new message.
 */
export const GetActiveRoomRequestSchema: GenMessage<GetActiveRoomRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_call, 9);

/**
 * Ответ с активной комнатой.
 *
 * @generated from message yofis.v1.GetActiveRoomResponse
 */
export type GetActiveRoomResponse = Message<"yofis.v1.GetActiveRoomResponse"> & {
  /**
   * Комната.
   *
   * @generated from field: yofis.v1.Room room = 1;
   */
  room?: Room | undefined;
};

/**
 * Describes the message yofis.v1.GetActiveRoomResponse.
 * Use `create(GetActiveRoomResponseSchema)` to create a new message.
 */
export const GetActiveRoomResponseSchema: GenMessage<GetActiveRoomResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_call, 10);

/**
 * Запрос активных комнат; полей нет.
 *
 * @generated from message yofis.v1.ListActiveRoomsRequest
 */
export type ListActiveRoomsRequest = Message<"yofis.v1.ListActiveRoomsRequest"> & {
};

/**
 * Describes the message yofis.v1.ListActiveRoomsRequest.
 * Use `create(ListActiveRoomsRequestSchema)` to create a new message.
 */
export const ListActiveRoomsRequestSchema: GenMessage<ListActiveRoomsRequest> = /*@__PURE__*/
  messageDesc(file_yofis_v1_call, 11);

/**
 * Ответ с активными комнатами.
 *
 * @generated from message yofis.v1.ListActiveRoomsResponse
 */
export type ListActiveRoomsResponse = Message<"yofis.v1.ListActiveRoomsResponse"> & {
  /**
   * Комнаты.
   *
   * @generated from field: repeated yofis.v1.Room rooms = 1;
   */
  rooms: Room[];
};

/**
 * Describes the message yofis.v1.ListActiveRoomsResponse.
 * Use `create(ListActiveRoomsResponseSchema)` to create a new message.
 */
export const ListActiveRoomsResponseSchema: GenMessage<ListActiveRoomsResponse> = /*@__PURE__*/
  messageDesc(file_yofis_v1_call, 12);

/**
 * Комнаты звонков. Уровень всех методов — signed; при выключенных звонках — CAPABILITY_DISABLED.
 *
 * @generated from service yofis.v1.CallService
 */
export const CallService: GenService<{
  /**
   * Создать комнату; один активный Room на чат — повтор возвращает существующую.
   * Уровень: signed. Ошибки: CAPABILITY_DISABLED, NOT_MEMBER, IDEMPOTENCY_CONFLICT.
   *
   * @generated from rpc yofis.v1.CallService.CreateRoom
   */
  createRoom: {
    methodKind: "unary";
    input: typeof CreateRoomRequestSchema;
    output: typeof CreateRoomResponseSchema;
  },
  /**
   * Войти в комнату: токен LiveKit и адрес медиасервера.
   * Уровень: signed. Ошибки: NOT_MEMBER, not_found (комната завершена).
   *
   * @generated from rpc yofis.v1.CallService.JoinRoom
   */
  joinRoom: {
    methodKind: "unary";
    input: typeof JoinRoomRequestSchema;
    output: typeof JoinRoomResponseSchema;
  },
  /**
   * Выйти из комнаты (медиасессия закрывается сервером).
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.CallService.LeaveRoom
   */
  leaveRoom: {
    methodKind: "unary";
    input: typeof LeaveRoomRequestSchema;
    output: typeof LeaveRoomResponseSchema;
  },
  /**
   * Завершить комнату для всех: создатель или ADMIN чата.
   * Уровень: signed. Ошибки: ROLE_REQUIRED.
   *
   * @generated from rpc yofis.v1.CallService.EndRoom
   */
  endRoom: {
    methodKind: "unary";
    input: typeof EndRoomRequestSchema;
    output: typeof EndRoomResponseSchema;
  },
  /**
   * Активная комната чата.
   * Уровень: signed. Ошибки: not_found, если нет.
   *
   * @generated from rpc yofis.v1.CallService.GetActiveRoom
   */
  getActiveRoom: {
    methodKind: "unary";
    input: typeof GetActiveRoomRequestSchema;
    output: typeof GetActiveRoomResponseSchema;
  },
  /**
   * Все активные комнаты, куда я могу войти.
   * Уровень: signed.
   *
   * @generated from rpc yofis.v1.CallService.ListActiveRooms
   */
  listActiveRooms: {
    methodKind: "unary";
    input: typeof ListActiveRoomsRequestSchema;
    output: typeof ListActiveRoomsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_yofis_v1_call, 0);

